<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="listTask"
      single-expand
      :loading="loading"
      item-key="callid"
      class="alignTableOnBackground ml-5 mr-5 elevation-1"
    >
      <template v-slot:item.progress="{ item }">
        <div style="width: 150px;">
          <v-progress-linear
            :value="progressPercentage(item)"
            color="#27e96a"
            height="20"
            striped
          >
            <strong>{{ Math.ceil(progressPercentage(item)) }}%</strong>
          </v-progress-linear>
        </div>
      </template>
      <template v-slot:item.state="{ item }">
        <v-chip outlined :color="getColorStatus(item)" class="ma-2" small>
          {{ item.state }}
        </v-chip>
      </template>
      <template v-slot:item.expireat="{ item }">
        {{ item.expireat | fmtDate("yyyy-MM-dd") }}
      </template>
      <template v-slot:item.created="{ item }">
        {{ item.created | fmtDate("yyyy-MM-dd") }}
      </template>
      <template v-slot:item.actions="{ item }">
        <v-btn
          v-if="isExpired(item) && item.customer_storage_id === null"
          icon
          small
          @click="downloadJobs(item)"
        >
          <v-icon>mdi-folder-download</v-icon>
        </v-btn>
        <v-btn v-if="item.customer_storage_id > 0" icon small>
          <v-icon>mdi-cloud-outline</v-icon>
        </v-btn>
      </template>
      <template v-slot:item.errors="{ item }">
        <v-badge
          v-if="errorCounter(item) > 0"
          :content="errorCounter(item)"
          :value="messages"
          color="red"
          overlap
        >
          <v-btn @click="openModal(item)" icon small>
            <v-icon>mdi-alert-remove</v-icon>
          </v-btn>
        </v-badge>
      </template>
    </v-data-table>
    <v-alert
      style="margin-top: 20px;"
      v-model="showError"
      dismissible="true"
      icon="mdi-alert-circle-outline"
      prominent
      text
      type="error"
    >
      {{ textError }}
    </v-alert>
    <taskModal
      :isActive="isActiveModal"
      :errorsList="selectItem"
      @close="isActiveModal = false"
    />
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import Vue from "vue";
import { fmtDate } from "@/lib/filters";
import { httpByCurrentCustomer } from "../../lib/client";
import { Task } from "@/entities/task";
import { DateTime } from "luxon";
import taskModal from "./taskModal";
export default {
  data: () => ({
    showError: false,
    textError: "",
    selectItem: "",
    isActiveModal: false,
    headers: [
      { text: "Tarea", value: "zipfile", sortable: "true" },
      { text: "Llamadas a Procesar", value: "calls", sortable: "true" },
      {
        text: "Llamadas Procesadas",
        value: "callsprocessed",
        sortable: "true",
      },
      {
        text: "",
        value: "progress",
        sortable: "false",
      },
      { text: "Estado", value: "state", sortable: "true" },
      { text: "Errores", value: "errors", sortable: "true" },

      { text: "Fecha de Creacion", value: "created", sortable: "true" },
      { text: "Fecha de Expiración", value: "expireat", sortable: "true" },
      { text: "", value: "actions", sortable: "false" },
    ],
  }),
  components: {
    taskModal,
  },
  methods: {
    openModal(item) {
      this.selectItem = JSON.parse(item.errors);
      this.isActiveModal = true;
    },
    errorCounter(item) {
      if (item.errors) {
        return JSON.parse(item.errors).length || 0;
      }
    },
    downloadJobs(item) {
      const json = {
        uid: item.uid,
      };
      httpByCurrentCustomer()
        .post("job/download", { json })
        .json()
        .then((res) => {
          window.open(res.urlzipfile);
        })
        .catch((error) => {
          this.showMessageError("Ha ocurrido un error, intente mas tarde.");
        });
    },
    isExpired(item) {
      const expireat = DateTime.fromISO(item.expireat);
      return expireat >= DateTime.local();
    },
    progressPercentage(item) {
      return ((parseInt(item.callsprocessed) * 100) / item.calls).toFixed(1);
    },
    getColorStatus(item) {
      if (item.state === "finished") {
        return "green";
      } else if (item.state === "in progress") {
        return "cyan";
      } else if (item.state === "in verification") {
        return "deep-purple accent-4";
      } else if (item.state === "with errors") {
        return "orange";
      } else if (item.state === "fatal error") {
        return "red";
      } else if (item.state === "in uploading") {
        return "teal";
      }
      return "";
    },
    showMessageError(message) {
      this.textError = message;
      this.showError = true;
    },
  },
  computed: {
    ...mapGetters("task", { listTask: "taskTable" }), // Traemos los valores
  },
  created() {
    this.$store.dispatch("task/getAllTask");
  },
  filters: {
    fmtDate,
  },
};
</script>

<style></style>
